import { CartItem } from "../typings/interfaces/pos/cart-item";

// Redo items are free. Alteration Only zeroes just the base garment price;
// its alterations, upcharges and spots are still charged. `specialCharge` is
// the item's Special ticket charge (util/special-charge), 0 on Regular.
export const getItemTotal = (item: CartItem, specialCharge = 0) => {
  if (item.redoDetails) return 0;
  const base = item.alterationOnly ? 0 : item.unitPrice * item.qty;
  return (
    base +
    item.alterationItems.reduce((acc, alt) => acc + (alt?.unitPrice ?? 0), 0) +
    item.upcharges.reduce((acc, upc) => acc + (upc?.subUpcharge.price ?? 0), 0) +
    item.spots.reduce((acc, spt) => acc + (spt?.subSpot.price ?? 0), 0) +
    specialCharge
  );
};
